
export const routes = (prefix = `master-data`) => [
    {
        path: `/${prefix}/accounts/item-collection`,
        name: `${prefix}.accounts.item-collection.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.accounts.item-collection.index`,
                PageDescription: "Accounts master data: Item Collection",
            },
        },
    },

];
